var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.student
    ? _c(
        "div",
        [
          _c(
            "v-card",
            {
              staticStyle: { "text-align": "left", padding: "9px" },
              attrs: { color: "grey lighten-5", raised: "" }
            },
            [
              _vm.student && _vm.$mq !== "mobile"
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("Name:")])]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.student.studentName))])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("Student ID:")])]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.student.studentExtId))])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("Birth Date:")])]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatDate")(_vm.student.birthDate))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("Gender:")])]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.student.gender))])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("Grade:")])]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.student.grade))])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("School Name:")])]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.student.schoolName))])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("Service Type:")])]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.student.serviceName))])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("Frequency:")])]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.student.frequency))])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [_c("strong", [_vm._v("ESY:")])]),
                        _vm._v(" "),
                        _c("span", [
                          _vm.student.esy
                            ? _c("span", [_vm._v("YES")])
                            : _c("span", [_vm._v("NO")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [
                          _c("strong", [_vm._v("Projected Start Date:")])
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatDate")(_vm.student.startDate))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm4: "", md3: "" } }, [
                        _c("span", [
                          _c("strong", [_vm._v("Projected End Date:")])
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatDate")(_vm.student.endDate))
                          )
                        ])
                      ])
                    ],
                    1
                  )
                : [
                    _c("div", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.student.studentName) +
                            " (" +
                            _vm._s(_vm.student.studentExtId) +
                            ")"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.student.schoolName))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "pr-3" }, [
                        _vm._v("Gr: " + _vm._s(_vm.student.grade))
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.student.serviceName) +
                          "\n      "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDate")(_vm.student.startDate)
                            ) +
                            " - " +
                            _vm._s(_vm._f("formatDate")(_vm.student.endDate)) +
                            "\n        "
                        )
                      ]),
                      _vm._v("\n        ESY:\n        "),
                      _vm.student.esy
                        ? _c("span", [_vm._v("YES")])
                        : _c("span", [_vm._v("NO")])
                    ])
                  ]
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecba2f92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecba2f92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/student-card/student-card.vue
// module id = null
// module chunks = 